module.exports = __webpack_public_path__ + "img/s3.1bc44a30.png";